import { useCallback } from 'react';
import { OutgoingEvents } from '~/components/ClientExperience/PublicTemplateIframeEvents/types';
import { useGlobalCX } from '~/components/ClientExperience/providers/global-context/useGlobalCX';

export const usePostMessageToParent = () => {
    const { configStore } = useGlobalCX();

    const postMessageToParent = useCallback(
        ({ event, data }: { event: OutgoingEvents; data? }) => {
            window.parent.postMessage(
                { type: event, data },
                configStore.isProduction() ? 'https://www.honeybook.com' : '*'
            );
        },
        [configStore]
    );

    return { postMessageToParent };
};
